export enum AddressType {
    TradingAddress = 1,
    BillingAddress = 2
}